import type { FeatureFlag } from '../entities/FeatureFlags';
import { useActiveUserQuery } from './useActiveUserQuery.hook';

export function useFeatureFlag(feature: FeatureFlag) {
  const activeUserQuery = useActiveUserQuery();
  const featureFlags = activeUserQuery.data.featureFlags;

  const isFeatureEnabled = (feature: FeatureFlag) => {
    return featureFlags?.[feature] ?? false;
  };

  return isFeatureEnabled(feature);
}

export function useAnyFeatureFlags(features: FeatureFlag[] | undefined) {
  const activeUserQuery = useActiveUserQuery();
  const featureFlags = activeUserQuery.data.featureFlags;
  if (!features) {
    return true;
  }

  return features.some(feature => featureFlags?.[feature] ?? false);
}

/** @knipignore */
export function useAllFeatureFlags(features: FeatureFlag[]) {
  const activeUserQuery = useActiveUserQuery();
  const featureFlags = activeUserQuery.data.featureFlags;

  return features.every(feature => featureFlags?.[feature] ?? false);
}
